import PropTypes from "prop-types";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * NavigationScroll component is used to scroll to top when the pathname changes.
 * 
 * @param {Object} props - The component props.
 * @param {ReactNode} props.children - The child components.
 * @return {ReactElement} The rendered NavigationScroll component.
 */
const NavigationScroll = ({ children }) => {
  /**
   * Hooks
   */
  const { pathname } = useLocation();
  
  /**
   * Scrolls to top when pathname changes.
   */
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, [pathname]);

  return children || null;
};

NavigationScroll.propTypes = {
  children: PropTypes.node
};

export default NavigationScroll;
